/**
 * Italian strings for the shared ContactForm.
 *
 * These keys are the subset the form's useTranslation() calls need.
 * The per-sede info (phone, email) can also be pulled from here
 * via footer.email / footer.phone, but the ContactForm also accepts
 * a `contactInfo` prop that overrides these at render time — which
 * is what Contattaci.tsx does so each sede shows its own data.
 */

export const it = {
  headlines: {
    contattaci: 'Contattaci',
  },
  contact: {
    intro:
      'Compila il form qui sotto per richiedere un sopralluogo gratuito. Ti rispondiamo entro 24 ore lavorative (lun–ven, 8:00–18:00).',
    name: 'Nome e cognome',
    email: 'Email',
    phone: 'Telefono',
    submit: 'Invia richiesta',
  },
  // Fallbacks used by the shared ContactForm when `contactInfo` prop
  // isn't provided. Overridden at render time in landings.
  footer: {
    email: 'info@verdevercelli.it',
    phone: '+39 348 438 4139',
  },
} as const
